import { render, staticRenderFns } from "./KpiCardComponent.vue?vue&type=template&id=af05cbb4&scoped=true&"
import script from "./KpiCardComponent.vue?vue&type=script&lang=js&"
export * from "./KpiCardComponent.vue?vue&type=script&lang=js&"
import style0 from "./KpiCardComponent.vue?vue&type=style&index=0&id=af05cbb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af05cbb4",
  null
  
)

export default component.exports